import { render } from "./FlashCard.vue?vue&type=template&id=44c581e4"
import script from "./FlashCard.vue?vue&type=script&lang=js"
export * from "./FlashCard.vue?vue&type=script&lang=js"

import "./FlashCard.vue?vue&type=style&index=0&id=44c581e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__